/**
 * CHARGE_INVOICES_ACTIONS (AF-4126): as quatro ações do modal de faturas do título, uma embaixo da outra.
 */
import ACheckbox from '../../../atoms/ACheckbox';
import { CHARGE_INVOICES_ACTIONS_FALLBACK, ChargeInvoicesActions } from '../services/chargeInvoicesActions';
import { parseJson } from '../services/businessPropertyRules';

interface Props {
    value: string;
    onChange: (value: string) => void;
}

const ACTIONS: { key: keyof ChargeInvoicesActions; label: string }[] = [
    { key: 'NEW_INVOICE', label: 'Nova Fatura' },
    { key: 'OPERATION_WATERFALL', label: 'Amortizar Operação' },
    { key: 'CANCEL', label: 'Cancelar Fatura' },
    { key: 'UNCOLLECT', label: 'Deixar de Cobrar / Cobrar Fatura' },
];

const ChargeInvoicesActionsEditor = ({ value, onChange }: Props) => {
    const actions = parseJson<ChargeInvoicesActions>(value, CHARGE_INVOICES_ACTIONS_FALLBACK);

    return (
        <div className="flex flex-col gap-3 text-sm text-gray-700 dark:text-gray-200">
            {ACTIONS.map(({ key, label }) => (
                <div key={key} className="flex items-center gap-2">
                    <ACheckbox
                        ariaLabel={`${label} (${key})`}
                        checked={actions[key]}
                        onChange={checked => onChange(JSON.stringify({ ...actions, [key]: checked }))}
                    />
                    <span>{label} <span className="text-gray-400">({key})</span></span>
                </div>
            ))}
        </div>
    );
};

export default ChargeInvoicesActionsEditor;
